import React, { useEffect, useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import CustomInput from '../../components/custominput/CustomInput';
import { runInAction } from 'mobx';

const DISPLAY_TYPE = {
  linkedIn: 'text',
  bio: 'long',
} as any;

const LABEL = {
  linkedIn: 'LinkedInURL',
  bio: 'BioDescription',
} as any;

const ORDEREXTRA_PATH = {
  linkedIn: 'LinkedIn',
  bio: 'ProfileBio',
} as any;

const CustomField = observer((props: any) => {
  const {
    settings,
    environment,
    fields,
    editInlineLabel = false,
    orders,
    activePersonNo,
    validations,
    validate,
    contentModuleId,
    updateOrder,
    checkConditions,
  } = props;
  const { fieldId, prefixClassName = 'cms-field', type, readonly, required, confirmInput = false, minLength = 0, disableChangeLock } = settings;

  const validity = useMemo(() => validations.find(v => v.id === contentModuleId), [validations]);
  const orderExtra = useMemo(() => orders?.[activePersonNo]?.orderExtra?.find((oe: any) => oe.name === ORDEREXTRA_PATH[type]), [orders, type, activePersonNo]);

  const handleChange = useCallback(
    (event: any) => {
      const orderCopy = { ...orders[activePersonNo] };
      if (!orders[activePersonNo]?.orderExtra) {
        orderCopy.orderExtra = [];
      }

      const target = ORDEREXTRA_PATH[type];
      const index = orderCopy?.orderExtra?.findIndex((oe: any) => oe.name === target);

      if (index !== -1) {
        orderCopy.orderExtra[index].value = event.target.value;
      } else {
        orderCopy.orderExtra.push({
          name: target,
          value: event.target.value,
        });
      }

      updateOrder(orderCopy);

      const isValid = !!(required ? event.target.value : true);

      if (validity) {
        runInAction(() => {
          validity.valid = isValid;
        });
      }
      checkConditions();
    },
    [orders, activePersonNo, validity, checkConditions, type, updateOrder]
  );

  const isValid = useMemo(() => {
    // if (!disableChangeLock && orders?.[0]?.badgeNo) return true;
    if (orderExtra?.value > 0 && validity?.valid === false) return false;
    else if (orderExtra?.value > 0 && validity?.valid === true) return true;
    else if (validate && validity?.valid === false) return false;
    return undefined;
  }, [validity, orderExtra, validate, validations, disableChangeLock, contentModuleId]);


  return (
    <CustomInput
      id={settings.fieldId}
      moduleType={'FIELD'}
      editable={true}
      readonly={readonly}
      required={required}
      onChange={(e: any) => handleChange(e)}
      value={orderExtra?.value || ''}
      valid={isValid}
      editInlineLabel={editInlineLabel}
      prefixClassName={prefixClassName + ` ${type}`}
      displayType={DISPLAY_TYPE[type]}
      eventId={environment.eventId}
      settings={settings}
      lang={environment.lang}
      showConfirmInput={confirmInput}
      label={LABEL[type]}
      staticLabel
    />
  );
});

export default CustomField;
